import React from 'react';

import { ActionBar } from '@gogame/components';
import { useScreenTitle } from '@gogame/screens';

export default () => {
  const [screenTitle] = useScreenTitle();
  return <ActionBar title={screenTitle} />;
};
